module.exports = __webpack_public_path__ + "media/images/young_pin_design_award_participate_icon-w-27f30f927e6ec4bccaed30f8a8552b31.png";